import { render, staticRenderFns } from "./laborerPaymentDetail.vue?vue&type=template&id=d4ae8858&scoped=true"
import script from "./laborerPaymentDetail.vue?vue&type=script&lang=js"
export * from "./laborerPaymentDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4ae8858",
  null
  
)

export default component.exports